import ApiService from "./api";

const Asset = {
    get(code, params) {
        return ApiService.get('asset/'+code, {params: params});
    },
    download(code, params) {
        return ApiService.download('asset/'+code+'/download', params);
    },
};

export default Asset;